// extracted by extract-css-chunks-webpack-plugin
module.exports = {"container":"_1eDYUR","inline":"_1x8O76","block":"ORRs5T","fullWidth":"_2E16tL","trigger":"_1egZ-j","button":"_1zkgu8","icon":"Li62T5","icon--disabled":"wNY-a5"};